import type { PlayerSeasonStatRow } from '../../services/player/playerSeasonStats'
import { toStatText } from './statText'

// The Penalty Minutes stat's abbreviation in the season-stats response.
const PIM_ABBR = 'PiM'

/**
 * Total penalty minutes across every team/season row: sum the `PiM` stat. The
 * value is usually stringified in the API (sometimes a number);
 * non-numeric/missing entries count as 0.
 */
export const getPenaltyMinutesTotal = (rows: PlayerSeasonStatRow[]): number => {
  let total = 0
  for (const row of rows ?? []) {
    for (const stat of row.stats ?? []) {
      const abbr = toStatText(stat.type?.abbr ?? stat.abbr)
      if (abbr !== PIM_ABBR) {
        continue
      }
      const n = Number(toStatText(stat.value))
      if (!Number.isNaN(n)) {
        total += n
      }
    }
  }
  return total
}
